import { useEffect, useState } from 'react'
import { FacilityParams } from 'app/models/facility-params'
import { useDispatch, useSelector } from 'react-redux'
import { loadAllFacilities } from 'app/state/ducks/facilities/thunks'
import { getFacilities } from 'app/state/ducks/facilities/selectors'
import { useNavigate, useParams } from 'react-router-dom'
import { formatNumberToCurrency } from 'app/utils/util-functions'
import { NonProRataIconWithTooltip } from 'app/views/components/icons/NonProRataIconWithTooltip'
import FacilityHoldIndicator from 'app/views/components/facility-hold-indicator'
import 'app/styles/components/related-facilities-table.css'


export default function DealRelatedFacilitiesDetails() {
  const dispatch = useDispatch()
  const { facilityId } = useParams()
  const { dealId } = useParams()

  const facilities: FacilityParams[] = useSelector(getFacilities)
  const [relatedFacilities, setRealatedFacilities] = useState<FacilityParams[]>(
    []
  )
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(loadAllFacilities())
  }, [])

  useEffect(() => {
    if (Array.isArray(facilities)) {
      if (facilityId) {
        const facility = facilities?.find(f => f.id === facilityId)
        const filtered = facilities?.filter(
          f => f.dealId.id === facility?.dealId.id && f.id !== facilityId
        )
        // Sort facilities alphabetically by name (case insensitive)
        const sorted = filtered?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''
          const nameB = b.name?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        setRealatedFacilities(sorted || [])
      }
      if (dealId) {
        const filtered = facilities?.filter(f => f.dealId.id === dealId)
        // Sort facilities alphabetically by name (case insensitive)
        const sorted = filtered?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''
          const nameB = b.name?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        setRealatedFacilities(sorted || [])
      }
    }
  }, [facilities, facilityId, dealId])

  const tableHeaders = [
    { key: 'name', label: 'Facility Name' },
    { key: 'amount', label: 'Amount' },
    { key: 'cusip', label: 'CUSIP' },
    { key: 'lxId', label: 'LX ID' },
    { key: 'systemId', label: 'Facility ID' },
    { key: 'facilityType', label: 'Facility Type' }
  ]


  return (
    <div className='related-facilities-container'>
      {relatedFacilities.length > 0 && (
        <div className='related-facilities-table'>
          {tableHeaders.map(header => (
            <div key={header.key} className='column'>
              <div className='column-header'>{header.label}</div>
              {relatedFacilities.map(facility => (
                <div
                  key={facility.id}
                  className='column-data clickable-row'
                  onClick={() => navigate(`/dealmanagement/facilities/${facility.id}/${facility.status}`)}
                >
                  {header.key === 'name' ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>{facility.name}</span>
                      <FacilityHoldIndicator facility={facility} enableLift />
                      {facility.hasNonProRataLoans === true && (
                        <NonProRataIconWithTooltip />
                      )}
                    </div>
                  ) : header.key === 'amount'
                    ? formatNumberToCurrency(facility[header.key as keyof FacilityParams] as number, facility.baseCurrency ?? 'USD')
                    : facility[header.key as keyof FacilityParams] as string}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
